import React from "react";
import { SelectChangeEvent } from "@mui/material";
import { Select, MenuItem, InputLabel, FormControl } from "./styles";

export interface SelectItemProps {
  label: string;
  value: string;
}

export interface SelectProps {
  width?: number;
  /** 상단 이름 */
  name?: string;
  /** 값 */
  value: string | number;
  /** 값이 변할때 실행될 함수 */
  selectHandler: (event: SelectChangeEvent<any>) => void;
  /** 디폴트 값 */
  defaultValue: string;
  /** 선택지 리스트 */
  list: SelectItemProps[];
}

export const SelectItem = ({ label, value }: SelectItemProps) => (
  <MenuItem value={value}>{label}</MenuItem>
);

export const SelectComponent = ({
  width = 200,
  name,
  value,
  selectHandler,
  defaultValue,
  list,
}: SelectProps) => {
  if (name) {
    return (
      <FormControl>
        <InputLabel id={name}>{name}</InputLabel>
        <Select
          width={width}
          labelId={name}
          id={name}
          value={value}
          onChange={selectHandler}
          defaultValue={defaultValue}
        >
          {list.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  } else {
    return (
      <Select
        width={width}
        value={value}
        onChange={selectHandler}
        defaultValue={defaultValue}
      >
        {list.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
};

export default SelectComponent;
